import { Box, useMediaQuery } from '@mui/material';

import youtube from 'assets/footer/youtube.svg';
import linkedin from 'assets/footer/linkedin.svg';
import logo from 'assets/logo.svg';

import {
  aboutMeta,
  autoDockingMeta,
  automatedDataPipelinesMeta,
  careersMeta,
  computerMeta,
  homeMeta,
  industriesMeta,
  maritimeMeta,
  mobileMeta,
  otherMeta,
  platformMeta,
  policyMeta,
} from 'constants/pages';
import { externalLinks } from 'constants/externalLinks';

import {
  FooterNavigation,
  Link,
  SocialMediaBox,
  SubText,
  LinksWrapper,
  CopyrightInfo,
  LinkTitle,
  // IndustriesList,
  LogoAndNav,
  FooterWrapper,
  LinksSectionCompany,
  LinksSectionPlatform,
  LinksSectionIndustries,
  PrivacyLink,
  InfoLink,
  IndustriesList,
  // LinksSection,
} from './Footer.style';
import { theme } from 'styles';

export const Footer = () => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <FooterWrapper component="footer">
      <FooterNavigation>
        <LogoAndNav>
          <Box className="logo-wrapper" alignItems="start" marginBottom="36px">
            <Link to={homeMeta.url}>
              <img src={logo} alt="logo icon" />
            </Link>
          </Box>

          <LinksWrapper>
            <LinksSectionPlatform>
              <LinkTitle>
                <Link to={platformMeta.url}>Platform</Link>
              </LinkTitle>
            </LinksSectionPlatform>

            {/* <LinksSectionIndustries>
              <LinkTitle>
                <Link to={industriesMeta.url}>Industries</Link>
              </LinkTitle>
              {/* {isDesktop && (
                <IndustriesList>
                  <Link to="">Mobile Machines</Link>
                  <Link to="">Maritime</Link>
                  <Link to="">Machine Vision</Link>
                  <Link to="">Others</Link>
                </IndustriesList>
              )} */}
            {/* </LinksSectionIndustries> */}

            <LinksSectionIndustries>
              <LinkTitle>
                <Link to="">Industries</Link>
              </LinkTitle>
              <IndustriesList>
                <Link to={industriesMeta.url}>All</Link>
                <Link to={mobileMeta.url}>Mobile Machines</Link>
                <Link to={maritimeMeta.url}>Maritime</Link>
                <Link to={computerMeta.url}>Machine Vision</Link>
                <Link to={otherMeta.url}>Others</Link>
              </IndustriesList>
            </LinksSectionIndustries>

            <LinksSectionCompany>
              <LinkTitle>
                <Link to="">Applications</Link>
              </LinkTitle>
              {/* {isDesktop && ( */}
              <>
                <Link to={automatedDataPipelinesMeta.url}>Training</Link>
                <Link to={autoDockingMeta.url}>Testing</Link>
              </>
              {/* // )} */}
            </LinksSectionCompany>

            <LinksSectionCompany>
              <LinkTitle>
                <Link to="">Company</Link>
              </LinkTitle>
              {/* {isDesktop && ( */}
              <>
                <Link to={aboutMeta.url}>About us</Link>
                <Link to={careersMeta.url}>Careers</Link>
              </>
              {/* // )} */}
            </LinksSectionCompany>

            {/* {!isDesktop && (
              <>
                <LinksSection>
                  <LinkTitle>
                    <Link to={platformMeta.url}>Applications</Link>
                  </LinkTitle>
                </LinksSection>

                <Box marginBottom="36px">
                  <LinkTitle>
                    <Link to={platformMeta.url}>Customer cases</Link>
                  </LinkTitle>
                </Box>
              </>
            )} */}
          </LinksWrapper>

          <Box display="flex" justifyContent="flex-end" marginBottom="36px">
            <InfoLink href="mailto:info@ailivesim.com">info@ailivesim.com</InfoLink>
          </Box>
        </LogoAndNav>

        <CopyrightInfo>
          {!isDesktop && (
            <SocialMediaBox marginBottom="16px">
              <a
                href={externalLinks.youTubeChannel}
                style={{
                  marginRight: '16px',
                }}
              >
                <img alt="youtube icon" src={youtube} />
              </a>

              <a href={externalLinks.linkedin}>
                <img alt="linkedin icon" src={linkedin} />
              </a>
            </SocialMediaBox>
          )}

          <SubText sx={{ marginBottom: '16px' }}>
            <Link to={policyMeta.url} style={{ margin: 0, fontSize: '12px', lineHeight: '15px' }}>
              <PrivacyLink>Privacy policy </PrivacyLink>
            </Link>
          </SubText>

          <SubText>
            © {new Date().getFullYear()}{' '}
            <Link
              style={{
                margin: 0,
                paddingLeft: '4px',
                fontSize: '12px',
                lineHeight: '15px',
                textDecoration: 'underline',
              }}
              to={homeMeta.url}
            >
              AILiveSim
            </Link>
            . All Rights Reserved
          </SubText>

          {isDesktop && (
            <SocialMediaBox>
              <a
                href={externalLinks.youTubeChannel}
                style={{
                  marginRight: '16px',
                }}
              >
                <img alt="youtube icon" src={youtube} />
              </a>

              <a href={externalLinks.linkedin}>
                <img alt="linkedin icon" src={linkedin} />
              </a>
            </SocialMediaBox>
          )}
        </CopyrightInfo>
      </FooterNavigation>
    </FooterWrapper>
  );
};
